import { MENU_ITEMS } from "@consts";

export default {
	name: "TheMobileNavigation",
	data() {
		return {
			menuData: [],
		};
	},
	computed: {
		topIndent() {
			const isPersistentSearch =
				this.$store.getters["navigation/isPersistentSearch"];
			const extraMargin = isPersistentSearch ? 8 : 0;
			return (
				this.$store.state.window.topAdHeight +
				extraMargin +
				this.$store.getters["window/headerHeight"]
			);
		},
		mobileMenuIsOpen() {
			return this.$store.state.navigation.mobileMenuIsOpen;
		},
	},
	methods: {
		closeSubMenus() {
			this.menuData.forEach((item) => {
				if (typeof item.submenuIsOpen === "boolean") {
					item.submenuIsOpen = false;
				}
			});
		},
		onLinkClick(entry) {
			this.dispatchGaEvent(entry);

			this.$store.commit("navigation/toggleMobileMenu", false);
			this.closeSubMenus();
		},
		onButtonClick(entry) {
			if (entry.submenuIsOpen) {
				entry.submenuIsOpen = false;
				this.dispatchGaEvent(entry);
				return;
			}

			this.closeSubMenus();

			if (typeof entry.submenuIsOpen === "boolean") {
				entry.submenuIsOpen = !entry.submenuIsOpen;
			}
			this.dispatchGaEvent(entry);
		},
		dispatchGaEvent(entry) {
			const eventCategory = "Header";
			const eventLabel = entry.labelDictionaryKey;
			const eventActionTranslation =
				entry.gaEventAction || this.$t(entry.labelDictionaryKey);
			const eventAction = `Click on ${eventActionTranslation} navigation element`;
			this.$store.dispatch("tracking/trackEvent", {
				eventCategory,
				eventAction,
				eventLabel,
			});
		},
		defaultIcon(icon) {
			if (!icon) {
				return;
			}
			return require(`~/assets/icons/${icon}`);
		},
	},
	created() {
		const reduceCallback = (acc, item) => {
			if (item.desktopOnly === true) {
				return acc;
			}

			if (Array.isArray(item.submenu)) {
				item.submenu.forEach((entry) => {
					entry.sectionEntries = entry.sectionEntries.reduce(
						reduceCallback,
						[]
					);
				});
			}

			acc.push({
				...item,
				title: item.title || item.label || "",
			});
			return acc;
		};

		this.menuData = MENU_ITEMS.reduce(reduceCallback, []);
	},
	watch: {
		mobileMenuIsOpen(value) {
			if (!value) {
				this.closeSubMenus();
			}
		},
	},
};
